import { render, staticRenderFns } from "./examCommitteeForm.vue?vue&type=template&id=adf79892&scoped=true&"
import script from "./examCommitteeForm.vue?vue&type=script&lang=js&"
export * from "./examCommitteeForm.vue?vue&type=script&lang=js&"
import style0 from "./examCommitteeForm.vue?vue&type=style&index=0&id=adf79892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf79892",
  null
  
)

export default component.exports